import React, { Component } from 'react'
import GuestRouter from 'config/routing/GuestRouter'
import ChangePwRouter from 'config/routing/ChangePwRouter'
import BrokerRouter from 'config/routing/BrokerRouter'
import AdminRouter from 'config/routing/AdminRouter'
import TesterRouter from 'config/routing/TesterRouter'
import { NotificationContainer } from 'react-notifications'
import { withRouter } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import Loader from 'components/general/Loader'
import ProfileSetupPending from 'components/general/ProfileSetupPending'
import brokerApi from 'config/api/BrokerAPI'
//import clientApi from 'config/api/ClientAPI'
import { DetailsProvider } from 'config/context/DetailsContext'
import { onError } from 'config/lib/errorLib'
import ErrorBoundary from 'components/general/ErrorBoundary'
import moment from 'moment-timezone'

// set default timezone for entire app
moment.tz.setDefault('Europe/Dublin')

const isLocal = process.env.NODE_ENV === 'development'

// Turn off logs in production
if (!isLocal) {
    console.log = function() {}
}

class App extends Component {
    constructor(props) {
        super(props)
        console.log(this.props)
        this.state = {
            loading: true,
            accountType: null,
            details: null,
            changePw: false,
            companyDetails: null,
            name: null,
            companyId: null,
            creatingCompany: false
        }
        this.api = new brokerApi()
        this.tablesPollingInterval = null
    }

    async componentDidMount() {
        await this.checkCurrentUser()
    }

    async checkCurrentUser() {
        try {
            const info = await Auth.currentUserInfo();
            console.log('info: ', info);
            console.log(this.props.authState);

            if (this.props.authState === 'signedIn' && (!info || Object.keys(info).length === 0)) {
                this.logout();
                return;
            }

            let accountType = info?.attributes?.['custom:account_type'] || null;
            let details = false;
            let companyId = info?.attributes?.['custom:company_id'] || null;
            let companyDetails = false;
            let changePw = false;
            let paymentMethod = false;

            if (accountType === 'broker') {
                companyDetails = await this.api.getCompanyDetails(companyId);
                console.log('company details: ', companyDetails);

                // Only attempt creation once if truly missing and not already creating
                if (!companyDetails && !this.state.creatingCompany) {
                    console.log('company details missing - initiating creation');
                    this.setState({ creatingCompany: true });
                    try {
                        let phone = info.attributes['phone_number'] || '';
                        let formattedEmail = info.attributes['email'] || '';
                        let firstName = info.attributes['name']?.split(' ')[0] || '';
                        let lastName = info.attributes['name']?.split(' ')[1] || '';
                        let companyName = info.attributes['custom:company_name'] || '';
                        let initialProducts = info.attributes['custom:initialProducts'] ? info.attributes['custom:initialProducts'].split(',') : ['All'];
                        // Create company
                        companyDetails = await this.api.addCompany(companyId, companyName, firstName, lastName, formattedEmail, phone, initialProducts);
                        console.log('company created, starting table creation...');
                        // Fire and forget table creation
                        this.api.createCompanyTables(companyId);
                    } catch (createErr) {
                        console.error('Failed to create company details:', createErr);
                        onError(createErr);
                    }
                }

                // Self-registered: has companyDetails.primaryPerson
                if (companyDetails.primaryPerson) {
                    if (companyDetails.brokerDiary) {
                        // Using CRM, add details
                        details = await this.api.getDetails(companyId);
                        console.log('using CRM details: ', details);
                        if (!details) {
                            let phone = info.attributes['phone_number'] || '';
                            let formattedEmail = info.attributes['email'] || '';
                            let firstName = info.attributes['name']?.split(' ')[0] || '';
                            let lastName = info.attributes['name']?.split(' ')[1] || '';
                            let permissions = info.attributes['custom:permissions'] || '';
                            details = await this.api.addDetails(companyId, firstName, lastName, formattedEmail, phone, permissions, ['All'], ['All']);
                        }
                        changePw = false;
                    } else {
                        // Not using CRM, use minimal user object
                        details = companyDetails.primaryPerson;
                        changePw = false;
                    }
                } else {
                    // Invited: no details, force change pw
                    details = await this.api.getDetails(companyId);
                    if (!details) {
                        let email = info.attributes['email'] || '';
                        let firstName = info.attributes['name']?.split(' ')[0] || '';
                        let lastName = info.attributes['name']?.split(' ')[1] || '';
                        let permissions = info.attributes['custom:permissions'] || '';
                        changePw = !email.endsWith('@brokerdiary.io');
                        details = {
                            firstName,
                            lastName,
                            permissions
                        };
                    } else {
                        changePw = false;
                    }
                }

                if (companyDetails?.stripeCustomerId) {
                    let paymentMethods = await this.api.getPaymentMethods(companyId, companyDetails.stripeCustomerId);
                    console.log('payment methods: ', paymentMethods);
                    paymentMethod = paymentMethods.paymentMethods && paymentMethods.paymentMethods.data.length > 0;
                }
            }
            console.log('DETAILS: ', details)

            this.setState({
                accountType: accountType,
                details: details,
                changePw: changePw,
                companyDetails: companyDetails,
                paymentMethod: paymentMethod,
                    loading: false,
                    companyId: companyId
            });
        } catch (e) {
            console.error('Error in checkCurrentUser:', e);
            onError(e);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Start polling if broker tables not yet created
        if (
            !this.tablesPollingInterval &&
            this.state.accountType === 'broker' &&
            this.state.companyDetails &&
            this.state.companyDetails.tablesCreated === false
        ) {
            this.startTablesPolling();
        }

        // If tables just became created, clear polling
        if (
            this.tablesPollingInterval &&
            this.state.companyDetails &&
            this.state.companyDetails.tablesCreated === true &&
            (!prevState.companyDetails || prevState.companyDetails.tablesCreated === false)
        ) {
            this.clearTablesPolling();
        }
    }

    componentWillUnmount() {
        this.clearTablesPolling();
    }

    startTablesPolling() {
        // Poll every 15 seconds (adjust as needed)
        this.tablesPollingInterval = setInterval(async () => {
            try {
                if (!this.state.companyId) return;
                const updatedCompanyDetails = await this.api.getCompanyDetails(this.state.companyId);
                if (updatedCompanyDetails) {
                    if (updatedCompanyDetails.tablesCreated) {
                        // Re-run full user check to populate details etc.
                        await this.checkCurrentUser();
                        this.clearTablesPolling();
                    } else {
                        // Just update the companyDetails reference so any other flags appear
                        this.setState({ companyDetails: updatedCompanyDetails });
                    }
                }
            } catch (err) {
                console.warn('Polling company tables creation failed:', err);
            }
        }, 60000);
    }

    clearTablesPolling() {
        if (this.tablesPollingInterval) {
            clearInterval(this.tablesPollingInterval);
            this.tablesPollingInterval = null;
        }
    }

    logout() {
        Auth.signOut().then((user) => {
            //window.location.replace('/')
            //this.props.history.push('/')
            console.log(user)
        }).catch(err => 
            onError(err)
        )
    }

    render() {
        return (
            <ErrorBoundary>
                <>
                    <NotificationContainer />
                        {!this.state.loading ? (
                            <>
                                {this.props.authState === 'signedIn' ? (
                                    <>
                                        {this.state.accountType === 'broker' && this.state.companyDetails && this.state.companyDetails.tablesCreated === false ? (
                                            <ProfileSetupPending />
                                        ) : (
                                            <>
                                                {this.state.accountType === 'broker' &&
                                                    <DetailsProvider value={this.state.companyDetails}>
                                                        {this.state.changePw ? (
                                                            <ChangePwRouter details={this.state.details} />
                                                        ) : (
                                                            <BrokerRouter companyDetails={this.state.companyDetails} details={this.state.details} paymentMethod={this.state.paymentMethod} />
                                                        )}
                                                    </DetailsProvider>
                                                }
                                                {this.state.accountType === 'admin' &&
                                                    <AdminRouter />
                                                }
                                                {this.state.accountType === 'tester' &&
                                                    <TesterRouter />
                                                }
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <GuestRouter />
                                )}
                            </>
                        ) : (
                            <Loader 
                                className='full-page-loader'
                            />
                        )}
                </>
            </ErrorBoundary>
        )
    }
}

export default withRouter(App)